<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  async created() {
    await this.$store.dispatch('setConfig');
    await this.$store.dispatch('login', { Vm: this });
  }
}
</script>

<style>
</style>
